// Quest Data - Sample STEM Quests
export const quests = {
    mathematics: [
        {
            id: 'math-001',
            title: 'Derivative Detective',
            description: 'Master the art of finding derivatives in calculus',
            difficulty: 'medium',
            xp: 150,
            estimatedTime: '20 min',
            icon: '📐',
            badges: ['calculus-novice'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is the derivative of x²?',
                    options: ['x', '2x', 'x³', '2'],
                    correctAnswer: 1,
                    explanation: 'Using the power rule: d/dx(x^n) = nx^(n-1), so d/dx(x²) = 2x'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'Find the derivative of sin(x)',
                    options: ['cos(x)', '-cos(x)', 'tan(x)', '-sin(x)'],
                    correctAnswer: 0,
                    explanation: 'The derivative of sin(x) is cos(x)'
                }
            ]
        },
        {
            id: 'math-002',
            title: 'Linear Algebra Legend',
            description: 'Explore vectors, matrices, and transformations',
            difficulty: 'hard',
            xp: 250,
            estimatedTime: '35 min',
            icon: '🔢',
            badges: ['matrix-master'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is a matrix?',
                    options: ['A mathematical table of numbers arranged in rows and columns', 'A type of vector', 'A function', 'A coordinate system'],
                    correctAnswer: 0,
                    explanation: 'A matrix is a rectangular array of numbers arranged in rows and columns'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'What is the determinant of a 2x2 matrix [[a, b], [c, d]]?',
                    options: ['a + b + c + d', 'ad - bc', 'ac - bd', 'ad + bc'],
                    correctAnswer: 1,
                    explanation: 'The determinant of a 2x2 matrix [[a, b], [c, d]] is ad - bc'
                }
            ]
        },
        {
            id: 'math-003',
            title: 'Probability Puzzle',
            description: 'Understand probability and statistics fundamentals',
            difficulty: 'easy',
            xp: 100,
            estimatedTime: '15 min',
            icon: '🎲',
            badges: ['stats-starter'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is the probability of rolling a 6 on a fair die?',
                    options: ['1/2', '1/3', '1/6', '1/12'],
                    correctAnswer: 2,
                    explanation: 'A fair die has 6 sides, so the probability of rolling any specific number is 1/6'
                }
            ]
        }
    ],
    physics: [
        {
            id: 'physics-001',
            title: 'Circuit Wizard',
            description: 'Learn basic electronics and circuit analysis',
            difficulty: 'easy',
            xp: 100,
            estimatedTime: '15 min',
            icon: '⚡',
            badges: ['circuit-novice'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is Ohm\'s Law?',
                    options: ['V = IR', 'E = mc²', 'F = ma', 'P = IV'],
                    correctAnswer: 0,
                    explanation: 'Ohm\'s Law states that Voltage = Current × Resistance (V = IR)'
                }
            ]
        },
        {
            id: 'physics-002',
            title: 'Quantum Quest',
            description: 'Dive into the strange world of quantum mechanics',
            difficulty: 'hard',
            xp: 300,
            estimatedTime: '40 min',
            icon: '🔬',
            badges: ['quantum-explorer'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is Planck\'s constant approximately equal to?',
                    options: ['6.63 × 10⁻³⁴ J·s', '3 × 10⁸ m/s', '6.67 × 10⁻¹¹ N·m²/kg²', '1.6 × 10⁻¹⁹ C'],
                    correctAnswer: 0,
                    explanation: 'Planck\'s constant (h) is approximately 6.63 × 10⁻³⁴ joule-seconds'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'According to Heisenberg\'s Uncertainty Principle, what cannot be simultaneously determined with perfect precision?',
                    options: ['Energy and momentum', 'Position and velocity', 'Energy and time', 'All of the above'],
                    correctAnswer: 3,
                    explanation: 'Heisenberg\'s Uncertainty Principle states there are fundamental limits to how precisely certain pairs of properties can be known'
                }
            ]
        },
        {
            id: 'physics-003',
            title: 'Mechanics Master',
            description: 'Newton\'s laws and classical mechanics',
            difficulty: 'medium',
            xp: 180,
            estimatedTime: '25 min',
            icon: '🎯',
            badges: ['mechanics-pro'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'According to Newton\'s Second Law, F = ma. What does this equation relate?',
                    options: ['Force, mass, and acceleration', 'Force, momentum, and velocity', 'Power, mass, and distance', 'Energy, mass, and acceleration'],
                    correctAnswer: 0,
                    explanation: 'Newton\'s Second Law states that the force applied to an object equals its mass times its acceleration (F = ma)'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'What is Newton\'s Third Law?',
                    options: ['For every action, there is an equal and opposite reaction', 'An object in motion stays in motion', 'Force equals mass times acceleration', 'Objects fall at the same rate'],
                    correctAnswer: 0,
                    explanation: 'Newton\'s Third Law states: For every action, there is an equal and opposite reaction'
                }
            ]
        }
    ],
    'computer-science': [
        {
            id: 'cs-001',
            title: 'Python Basics',
            description: 'Start your programming journey with Python',
            difficulty: 'easy',
            xp: 120,
            estimatedTime: '18 min',
            icon: '🐍',
            badges: ['python-beginner'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'Which keyword is used to define a function in Python?',
                    options: ['function', 'def', 'func', 'define'],
                    correctAnswer: 1,
                    explanation: 'In Python, functions are defined using the "def" keyword'
                }
            ]
        },
        {
            id: 'cs-002',
            title: 'Algorithm Architect',
            description: 'Master sorting and searching algorithms',
            difficulty: 'medium',
            xp: 200,
            estimatedTime: '30 min',
            icon: '🧩',
            badges: ['algo-expert'],
            prerequisites: ['cs-001'],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is the time complexity of binary search on a sorted array?',
                    options: ['O(n)', 'O(n²)', 'O(log n)', 'O(n log n)'],
                    correctAnswer: 2,
                    explanation: 'Binary search has O(log n) time complexity because it eliminates half of the remaining elements with each comparison'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'Which sorting algorithm is typically the fastest for most practical cases?',
                    options: ['Bubble sort', 'Quick sort', 'Selection sort', 'Insertion sort'],
                    correctAnswer: 1,
                    explanation: 'Quick sort is generally the fastest sorting algorithm with an average time complexity of O(n log n)'
                }
            ]
        },
        {
            id: 'cs-003',
            title: 'Data Structure Dynasty',
            description: 'Arrays, linked lists, trees, and graphs',
            difficulty: 'hard',
            xp: 280,
            estimatedTime: '45 min',
            icon: '🌳',
            badges: ['data-structure-master'],
            prerequisites: ['cs-001', 'cs-002'],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is the advantage of a linked list over an array?',
                    options: ['Faster access to elements', 'Less memory usage', 'Dynamic size and O(1) insertion/deletion', 'Better cache locality'],
                    correctAnswer: 2,
                    explanation: 'Linked lists provide dynamic sizing and can insert or delete elements in O(1) time if you have a reference to the position'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'What is the height of a balanced binary search tree with n nodes?',
                    options: ['n', 'log n', 'n²', 'n - 1'],
                    correctAnswer: 1,
                    explanation: 'A balanced binary search tree maintains a height of O(log n), which keeps search operations efficient'
                }
            ]
        }
    ],
    chemistry: [
        {
            id: 'chem-001',
            title: 'Periodic Table Pro',
            description: 'Master elements and their properties',
            difficulty: 'easy',
            xp: 90,
            estimatedTime: '12 min',
            icon: '⚗️',
            badges: ['element-explorer'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is the atomic number of Oxygen?',
                    options: ['6', '7', '8', '9'],
                    correctAnswer: 2,
                    explanation: 'Oxygen has an atomic number of 8, meaning it has 8 protons'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'Which element is a noble gas?',
                    options: ['Oxygen', 'Helium', 'Nitrogen', 'Hydrogen'],
                    correctAnswer: 1,
                    explanation: 'Helium is a noble gas, which are elements in Group 18 with full outer electron shells'
                }
            ]
        },
        {
            id: 'chem-002',
            title: 'Chemical Bonding Challenge',
            description: 'Understand ionic, covalent, and metallic bonds',
            difficulty: 'medium',
            xp: 160,
            estimatedTime: '22 min',
            icon: '🔗',
            badges: ['bonding-expert'],
            prerequisites: [],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What is an ionic bond?',
                    options: ['A bond between two nonmetals', 'An electrostatic attraction between ions', 'A bond with shared electrons', 'A metallic bond between atoms'],
                    correctAnswer: 1,
                    explanation: 'An ionic bond is formed by the electrostatic attraction between positively and negatively charged ions'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'In a covalent bond, electrons are:',
                    options: ['Transferred from one atom to another', 'Shared between atoms', 'Removed completely', 'Donated to the nucleus'],
                    correctAnswer: 1,
                    explanation: 'In a covalent bond, electrons are shared between two atoms'
                }
            ]
        },
        {
            id: 'chem-003',
            title: 'Organic Chemistry Quest',
            description: 'Explore carbon compounds and reactions',
            difficulty: 'hard',
            xp: 260,
            estimatedTime: '38 min',
            icon: '🧪',
            badges: ['organic-chemist'],
            prerequisites: ['chem-001', 'chem-002'],
            questions: [
                {
                    id: 'q1',
                    type: 'multiple-choice',
                    question: 'What makes carbon unique as an element in organic chemistry?',
                    options: ['It is the most abundant element', 'It has four valence electrons and can form strong bonds', 'It is always negatively charged', 'It never forms double bonds'],
                    correctAnswer: 1,
                    explanation: 'Carbon has four valence electrons, allowing it to form four strong covalent bonds, making it the basis of organic chemistry'
                },
                {
                    id: 'q2',
                    type: 'multiple-choice',
                    question: 'What is the general formula for an alkane?',
                    options: ['CₙH₂ₙ', 'CₙH₂ₙ₊₂', 'CₙHₙ', 'CₙH₂ₙ₋₂'],
                    correctAnswer: 1,
                    explanation: 'The general formula for saturated hydrocarbons (alkanes) is CₙH₂ₙ₊₂, where n is the number of carbon atoms'
                }
            ]
        }
    ]
};

export function getAllQuests() {
    return Object.values(quests).flat();
}

export function getQuestsBySubject(subject) {
    return quests[subject] || [];
}

export function getQuestById(id) {
    return getAllQuests().find(quest => quest.id === id);
}

export function getQuestsForUser(user) {
    const allQuests = getAllQuests();
    // Handle both local storage structure (flat) and backend structure (nested in progress)
    const completedList = user.completedQuests || (user.progress && user.progress.completedQuests) || [];
    const completedIds = new Set(completedList.map(q => typeof q === 'string' ? q : q.questId));

    return allQuests.map(quest => ({
        ...quest,
        isCompleted: completedIds.has(quest.id),
        isLocked: checkIfLocked(quest, completedIds)
    }));
}

function checkIfLocked(quest, completedIds) {
    if (!quest.prerequisites || quest.prerequisites.length === 0) {
        return false;
    }

    return !quest.prerequisites.every(prereq => completedIds.has(prereq));
}
